// extracted by mini-css-extract-plugin
export default {"switches":"ViewSwitches_switches__gkW49"};